import React from 'react';

const GuardEntryExitTable = ({ logs, loading, formatLogTime }) => {
  // Helper to format date from a datetime string
  const formatLogDate = (dateStr) => {
    if (!dateStr) return '--';
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return '--';
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = String(d.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  // Helper to determine row styling based on flags
  const getRowStyle = (log) => {
    const flags = log.flags || {};
    
    // Red background for late entries (after 8PM without gatepass OR after gatepass time)
    if (flags.lateAfter8PM || flags.lateGatepass) {
      return { backgroundColor: '#fee2e2' }; // Light red
    }
    
    // Yellow background for students currently outside
    if (flags.outside) {
      return { backgroundColor: '#fef3c7' }; // Light yellow/amber
    }
    
    return {};
  };

  return (
    <div className="guard-logs-table-wrapper">
      <div className="guard-logs-table-scroll">
        <table className="guard-logs-table">
          <colgroup>
            <col className="col-sr" />
            <col className="col-name" />
            <col className="col-roll" />
            <col className="col-room" />
            <col className="col-contact" />
            <col className="col-place" />
            <col className="col-purpose" />
            <col className="col-gp" />
            <col className="col-tout" />
            <col className="col-edate" />
            <col className="col-tin" />
            <col className="col-ndate" />
          </colgroup>
          <thead>
            <tr>
              <th>SR</th>
              <th>NAME</th>
              <th>ROLL NO.</th>
              <th>ROOM</th>
              <th>CONTACT</th>
              <th>PLACE</th>
              <th>PURPOSE</th>
              <th>GATE PASS</th>
              <th>TIME OUT</th>
              <th>EXIT DATE</th>
              <th>TIME IN</th>
              <th>ENTRY DATE</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={12}>Loading...</td>
              </tr>
            )}
            {!loading && logs.length === 0 && (
              <tr>
                <td colSpan={12}>No records</td>
              </tr>
            )}
            {!loading &&
              logs.map((l, idx) => {
                const s = l.student || {};
                const timeOut = formatLogTime(l.exitStatusTime);
                const timeIn = formatLogTime(l.entryStatusTime);
                const hasEntry = l.entryOutcome === 'approved';

                return (
                  <tr key={l._id} style={getRowStyle(l)}>
                    <td>{idx + 1}</td>
                    <td>{s.name || '-'}</td>
                    <td>{s.rollnumber || '-'}</td>
                    <td>{s.roomNumber || '-'}</td>
                    <td>{s.contactNumber || '-'}</td>
                    <td>{l.place || '-'}</td>
                    <td>{l.purpose || '-'}</td>
                    <td>{l.gatePassNo || '--'}</td>
                    <td>{timeOut || '-'}</td>
                    <td>{formatLogDate(l.exitStatusTime)}</td>
                    <td className={hasEntry ? 'guard-logs-time-in-done' : ''}>
                      {hasEntry ? timeIn : '--'}
                    </td>
                    <td>{hasEntry ? formatLogDate(l.entryStatusTime) : '--'}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GuardEntryExitTable;
